import { useEffect, useRef, useState } from "react";
import classes from "./OptionQuestion.module.css";
import PoorResponse from "./PoorResponse";

function sparkleTheme(option) {
  const label = String(option).toLowerCase();
  if (label.includes("excellent")) {
    return { color: "#7dff9a", glow: "rgba(70, 220, 120, 0.95)" };
  }
  if (label.includes("poor") || label.includes("bad")) {
    return { color: "#ff5c5c", glow: "rgba(255, 70, 70, 0.95)" };
  }
  return { color: "#ffe566", glow: "rgba(255, 210, 60, 0.95)" };
}

function createSparkleBurst(event) {
  const rect = event.currentTarget.getBoundingClientRect();
  const id = `${Date.now()}-${Math.random().toString(16).slice(2)}`;
  const particles = Array.from({ length: 24 }, (_, particleIndex) => {
    const angle = (Math.PI * 2 * particleIndex) / 24 + Math.random() * 0.35;
    const distance = 14 + Math.random() * 34;
    return {
      id: `${id}-${particleIndex}`,
      dx: Math.cos(angle) * distance,
      dy: Math.sin(angle) * distance,
      delay: (particleIndex % 8) * 16,
      size: particleIndex % 4 === 0 ? 12 : particleIndex % 2 === 0 ? 8 : 5,
    };
  });

  return {
    id,
    x: event.clientX - rect.left,
    y: event.clientY - rect.top,
    particles,
  };
}

export default function OptionQuestion({
  data,
  index,
  onChangeHandle,
  isEmpty,
}) {
  // console.log(data);
  // in future if i want to have form that will ask more detailed answer if poor options is selected
  // then i will have a state here to track if poor options is selected,
  console.log(data);

  const [poorSelected, setPoorSelected] = useState(false);
  const [selectedOption, setSelectedOption] = useState("");
  const [sparkles, setSparkles] = useState([]);
  const sparkleTimers = useRef([]);

  useEffect(() => {
    const timers = sparkleTimers.current;
    return () => {
      timers.forEach((timerId) => window.clearTimeout(timerId));
    };
  }, []);

  const [wordCount, setWordCount] = useState(150);
  if (data === undefined) return;
  let poorString = data.options[3];

  function changeHandler(e, title) {
    let response = e;

    onChangeHandle(title, response);
    if (title === "foodIssue" || title === "foodNameHavingIssue") {
      return;
    }

    setSelectedOption(response);

    if (poorString === response && title.includes("Food")) {
      setPoorSelected(true);
    } else {
      setPoorSelected(false);
    }
  }

  function wordCountHandler(term, value) {
    if (term === "description") {
      setWordCount((p) => {
        return 150 - value.length;
      });
    }
  }
  return (
    <div
      key={`sa${index}sss ${index}`}
      className={`${classes.optionQuestionContainer} ${
        isEmpty && classes.emptyLabelContainer
      }`}
    >
      <p>
        {" "}
        {index > -1 && <span>{index + 1}. </span>}
        {data.title}
      </p>
      <div className={classes.optionList}>
        {data.options.map((item, optionIndex) => {
          const isSelected = selectedOption === item;
          return (
            <button
              key={`${data.title}-${optionIndex}`}
              type="button"
              className={`${classes.optionBox} ${
                isSelected ? classes.optionBoxSelected : ""
              }`}
              aria-pressed={isSelected}
              onPointerDown={(event) => {
                if (event.pointerType === "mouse" && event.button !== 0) {
                  return;
                }
                if (
                  window.matchMedia("(prefers-reduced-motion: reduce)").matches
                ) {
                  return;
                }
                const burst = createSparkleBurst(event);
                const theme = sparkleTheme(item);
                setSparkles((current) => [
                  ...current,
                  { ...burst, optionIndex, ...theme },
                ]);
                const timerId = window.setTimeout(() => {
                  setSparkles((current) =>
                    current.filter((sparkle) => sparkle.id !== burst.id)
                  );
                }, 850);
                sparkleTimers.current.push(timerId);
              }}
              onClick={() => changeHandler(item, data.title)}
            >
              {item}
              {sparkles
                .filter((sparkle) => sparkle.optionIndex === optionIndex)
                .map((sparkle) => (
                  <span
                    key={sparkle.id}
                    className={classes.sparkleBurst}
                    style={{
                      left: sparkle.x,
                      top: sparkle.y,
                      "--sparkle-color": sparkle.color,
                      "--sparkle-glow": sparkle.glow,
                    }}
                    aria-hidden="true"
                  >
                    {sparkle.particles.map((particle) => (
                      <span
                        key={particle.id}
                        className={classes.sparkle}
                        style={{
                          "--dx": `${particle.dx}px`,
                          "--dy": `${particle.dy}px`,
                          "--sparkle-size": `${particle.size}px`,
                          width: particle.size,
                          height: particle.size,
                          animationDelay: `${particle.delay}ms`,
                        }}
                      />
                    ))}
                  </span>
                ))}
            </button>
          );
        })}
      </div>
      {poorSelected && (
        <>
          <PoorResponse
            wordCountHandler={wordCountHandler}
            wordCount={wordCount}
            getFoodIssue={changeHandler}
          />{" "}
        </>
      )}
    </div>
  );
}
